import { z } from 'zod';
import { CalendarEvent } from './event.js';
export const CalendarEventResponse = z.object({ event: CalendarEvent });
export const CalendarEventListResponse = z.object({
    events: z.array(CalendarEvent),
    total: z.number().int().nonnegative(),
    limit: z.number().int().nonnegative(),
    offset: z.number().int().nonnegative(),
    /** Echo back the server-clamped query window so clients can
     *  detect rounding (the service clamps `to` if it exceeds the
     *  370-day cap, but only when the caller didn't already trip the
     *  hard error — defensive, lets a future cap relaxation degrade
     *  gracefully). */
    from: z.string().datetime({ offset: true }),
    to: z.string().datetime({ offset: true }),
});
export const CalendarCapabilitiesResponse = z.object({
    calendarEnabled: z.boolean(),
    recurrenceEnabled: z.boolean(),
    eventRemindersEnabled: z.boolean(),
    canCreatePrivateEvents: z.boolean(),
    canManageAllCalendarEvents: z.boolean(),
    writableGroupIds: z.array(z.string().uuid()),
});
//# sourceMappingURL=responses.js.map